<template>
  <div></div>
</template>

<script>
import cityConfig from './cityConfig';

export default {
  name: 'CityRouter',
  created () {

    const path       = this.$router.history.current.path,
          toRegister = path.indexOf('/cadastre-se') != -1,
          city       = path.replace('/cadastre-se', '')

    switch (city) {
      case '/bhz':
      case '/belo-horizonte':
        this.$root.app = cityConfig['bhz'];
        break;

      case '/ftz':
      case '/fortaleza':
        this.$root.app = cityConfig['ftz'];
        break;

      case '/ssa':
      case '/salvador':
        this.$root.app = cityConfig['ssa'];
        break;

      case '/cwb':
      case '/curitiba':
        this.$root.app = cityConfig['cwb'];
        break;

      case '/cjz':
      case '/cajazeiras':
        this.$root.app = cityConfig['cjz'];
        break;

      case '/jdn':
      case '/juazeirodonorte':
        this.$root.app = cityConfig['jdn'];
        break;

      case '/mon':
      case '/mongagua':
        this.$root.app = cityConfig['mon'];
        break;

      case '/sgr':
      case '/salgueiro':
        this.$root.app = cityConfig['sgr'];
        break;

      // estapar
      case '/ame':
      case '/americana':
        this.$root.app = cityConfig['ame'];
        break;
      
      case '/ara':
      case '/araraquara':
        this.$root.app = cityConfig['ara'];
        break;
      
      case '/ita':
      case '/itatiba':
        this.$root.app = cityConfig['ita'];
        break;

      case '/jac':
      case '/jacarei':
        this.$root.app = cityConfig['jac'];
        break;

      case '/jzf':
      case '/juiz-de-fora':
        this.$root.app = cityConfig['jzf'];
        break;
      
      case '/lim':
      case '/limeira':
        this.$root.app = cityConfig['lim'];
        break;
      
      case '/mog':
      case '/mogi-das-cruzes':
        this.$root.app = cityConfig['mog'];
        break;
      
      case '/ric':
      case '/rio-claro':
        this.$root.app = cityConfig['ric'];
        break;
      
      case '/sbc':
      case '/sao-bernardo-do-campo':
        this.$root.app = cityConfig['sbc'];
        break;
      
      case '/sbo':
      case '/santa-barbara-d-oeste':
        this.$root.app = cityConfig['sbo'];
        break;
 
      case '/sca':
      case '/sao-carlos':
        this.$root.app = cityConfig['sca'];
        break;
      
      case '/sbv':
      case '/sao-joao-da-boa-vista':
        this.$root.app = cityConfig['sbv'];
        break;

      case '/sta':
      case '/santo-andre':
        this.$root.app = cityConfig['sta'];
        break;
      
      case '/tau':
      case '/taubate':
        this.$root.app = cityConfig['tau'];
        break;

      case '/mau':
      case '/maua':
        this.$root.app = cityConfig['mau'];
        break;
      
      default:
        this.$root.app = cityConfig['default'];
        break;
    }

    this.$http.defaults.headers.common['X-City'] = this.$root.app.city
    localStorage.setItem('zul_app', JSON.stringify(this.$root.app))

    if (toRegister) {
      this.$router.push('../register')
    } else {
      this.$router.push('../')
    }

     window.location.reload()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
